import React, { useState } from 'react';
import { CgClose } from 'react-icons/cg';
import projectCategory from '../../helpers/ProjectCategory';
import { FaCloudUploadAlt } from 'react-icons/fa';
import DisplayImage from '../DisplayImage';
import { MdDelete } from 'react-icons/md';
import { v4 as uuidv4 } from "uuid";
import {getDownloadURL,getStorage,ref,uploadBytesResumable} from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { toast } from 'react-toastify';
import "../../css/Admin-Projects/AdminEditProduct.css";
import Spinner from '../Spinner';


const AdminEditProduct = ({ onClose, productData, fetchData,projectKey }) => {
    const [uploadProgressImage, setuploadProgressImage] = useState(0);
    const [uploadProgressVideo, setuploadProgressVideo] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        ...productData,
        projectName: productData?.projectName,
        projectCategory: productData?.projectCategory,
        projectImage: productData?.projectImage || [],
        projectVideo: productData?.projectVideo,
        projectDescription: productData?.projectDescription,
        projectGitLink: productData?.projectGitLink,
    });

    const [fullScreenImage, setFullScreenImage] = useState("");
    const [openFullScreenImage, setOpenFullScreenImage] = useState(false);

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setData((pre)=>{
            return{
                ...pre,
                [name]:value
            }
        })
    };

    

    async function handleUploadProduct(e) {
        setLoading(true);
        const image = e.target.files[0];
        return new Promise((resolve, reject) => {
            const storage = getStorage();
            const filename = `${data?.projectName}-${image.name}-${uuidv4()}`;
            const storageRef = ref(storage, filename);
            const uploadTask = uploadBytesResumable(storageRef, image);
            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    // Handle state changes such as progress, pause, and resume
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log("Upload is " + progress + "% done");
                    setuploadProgressImage(progress);
                    switch (snapshot.state) {
                        case "paused":
                            console.log("Upload is paused");
                            break;
                        case "running":
                            console.log("Upload is running");
                            break;
                    }
                },
                (error) => {
                    reject(error);
                    setLoading(false);
                },
                () => {
                    // Handle successful uploads on complete
                    // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        resolve(downloadURL);
                        //console.log(downloadURL);
                        setData((prev) => ({
                            ...prev,
                            projectImage: [...prev.projectImage, downloadURL]
                        }));
                        setLoading(false);
                    });
                }
            );
            setLoading(false);
        });

    }
    

    const handleDeleteProductImage = (index) => {
        //console.log("clicl");
        const newProductImage = [...data.projectImage];
        newProductImage.splice(index, 1);
        setData((pre)=>{
            return{
                ...pre,
                projectImage:[...newProductImage]
            }
        })
    };

    async function handleUploadProjectVideo(e) {
        setLoading(true);
        const video = e.target.files[0];
        return new Promise((resolve, reject) => {
            const storage = getStorage();
            const filename = `${data?.projectName}-${video.name}-${uuidv4()}`;
            const storageRef = ref(storage, filename);
            const uploadTask = uploadBytesResumable(storageRef, video);
            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log("Video Upload is " + progress + "% done");
                    setuploadProgressVideo(progress)
                },
                (error) => {
                    reject(error);
                    setLoading(false);
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        resolve(downloadURL);
                        //console.log(downloadURL);
                        setData((prev) => ({
                            ...prev,
                            projectVideo: [...(prev.projectVideo || []), downloadURL]
                        }));
                    });
                    setLoading(false);
                }
            );
            setLoading(false);
        });
    }
    const handleDeleteProjectVideo = (index) => {
        const newProjectVideo = [...data.projectVideo];
        newProjectVideo.splice(index, 1);
        setData((pre) => ({
            ...pre,
            projectVideo: newProjectVideo
        }));
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        //console.log(projectKey);
        const docRef=doc(db,"projects",projectKey)
        await updateDoc(docRef,data);
       setLoading(false)
        toast.success("Project Updated")
       fetchData()

       onClose()


    };
    if (loading) {
        return <Spinner />;
      }

    return (
        <div className="overlay">
            <div className="edit-product-modal">
                <div className='modal-header'>
                    <h2 className='title'>Edit Product</h2>
                    <div className='close-icon' onClick={onClose}>
                        <CgClose />
                    </div>
                </div>
                <form className='form' onSubmit={handleSubmit}>
                    <label htmlFor='projectName'>Project Name :</label>
                    <input 
                        type="text" 
                        id="projectName" 
                        placeholder='enter product name' 
                        value={data.projectName} 
                        name='projectName'
                        onChange={handleOnChange}
                        className='input'
                        required
                    />
                    <label htmlFor='projectGitLink'>Product GitLink :</label>
                    <input 
                        type="text" 
                        id="projectGitLink" 
                        placeholder='enter product name' 
                        value={data.projectGitLink} 
                        name='projectGitLink'
                        onChange={handleOnChange}
                        className='input'
                    />

                    <label htmlFor='category' className='label'>Category :</label>
                    <select required value={data?.projectCategory} name='projectCategory' onChange={handleOnChange} className='input'>
                        <option value="">Select Category</option> 
                        {projectCategory.map((el, index) => (
                            <option value={el.value} key={el.value + index}>{el.label}</option>
                        ))}
                    </select>

                    <label htmlFor='projectImage' className='label'>Product Image :</label>
                    <label htmlFor='uploadImageInput'>
                        <div className='upload-container'>
                            <div className='upload-content'>
                                <span className='upload-icon'><FaCloudUploadAlt /></span>
                                <p className='upload-text'>Upload Product Image</p>
                                <input type="file" id="uploadImageInput" className='hidden' onChange={handleUploadProduct} />
                            </div>
                        </div>
                    </label>
                    {uploadProgressImage > 0 && uploadProgressImage < 100 && (
            <label style={{color:'blue'}}>{`Upload is ${uploadProgressImage}% done`}</label>
          )}

                    <div>
                        {data?.projectImage ? (
                            <div className='image-preview'>
                                {data?.projectImage.map((el, index) => (
                                    <div className='image-container' key={index}>
                                        <img src={el} alt={el} className='image' onClick={() => {
                                            setOpenFullScreenImage(true);
                                            setFullScreenImage(el);
                                        }} />
                                        <div className='delete-icon' onClick={() => handleDeleteProductImage(index)}>
                                            <MdDelete />  
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className='error-text'>*Please Upload Product Image</p>
                        )}
                    </div>
                    <label htmlFor='projectVideo' className='label'>Project Video :</label>
                    <label htmlFor='uploadVideoInput'>
                        <div className='upload-container'>
                            <div className='upload-content'>
                                <span className='upload-icon'><FaCloudUploadAlt /></span>
                                <p className='upload-text'>Upload Project Video</p>
                                <input type="file" id="uploadVideoInput" className='hidden' onChange={handleUploadProjectVideo} />
                            </div>
                        </div>
                    </label>
                    {uploadProgressVideo > 0 && uploadProgressVideo < 100 && (
            <label style={{color:'blue'}}>{`Upload is ${uploadProgressVideo}% done`}</label>
          )}
                    <div>
                        {data.projectVideo.length > 0 ? (
                            <div className='video-preview'>
                                {data.projectVideo.map((el, index) => (
                                    <div className='video-container' key={index}>
                                        <video src={el} className='video' controls />
                                        <div className='video-delete-icon' onClick={() => handleDeleteProjectVideo(index)}>
                                            <MdDelete />  
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className='error-text'>*Please Upload Project Video</p>
                        )}
                    </div>
                    <label htmlFor='projectDescription' className='label'>Description :</label>
                    <textarea 
                        className='textarea' 
                        placeholder='enter product description' 
                        rows={3}
                        value={data.projectDescription}
                        name="projectDescription" 
                        onChange={handleOnChange}
                    />
                    <button className="submit-button">Update Product</button>
                </form>
            </div>
            {openFullScreenImage && (
                <DisplayImage onClose={() => setOpenFullScreenImage(false)} imageUrl={fullScreenImage} />
            )}
        </div>
    );
};

export default AdminEditProduct;
